/**
 * Counts how many members have a particular resourceId.
 *
 * @param {Array} members - The list of member objects.
 * @param {string} resourceId - The specific resourceId to search for.
 * @returns {number} - Number of members that have the given resourceId.
 */
export const countMembersWithResourceId = (members, resourceId) =>
  members?.filter((member) =>
    member.ownerships.some((ownership) => ownership.resource_id === resourceId)
  ).length ?? 0;

export default {
  countMembersWithResourceId,
};
